var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBigPegelPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M20.647 48.457C32.216 38.65 38 29.164 38 20c0-9.941-8.059-18-18-18S2 10.059 2 20c0 9.164 5.784 18.65 17.353 28.457a1 1 0 0 0 1.294 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "144.4%",
    height: "133.4%",
    x: "-22.2%",
    y: "-25.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14BAD8",
    d: "M20.647 48.457C32.216 38.65 38 29.164 38 20c0-9.941-8.059-18-18-18S2 10.059 2 20c0 9.164 5.784 18.65 17.353 28.457a1 1 0 0 0 1.294 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13191F",
    d: "M24.007 9C26.219 9 28 10.836 28 13.086l.002 6.23c.311.066.612.141.902.224.717.205 1.241.415 1.544.566a1 1 0 0 1-.895 1.789c-.197-.099-.608-.263-1.2-.432a11.334 11.334 0 0 0-.352-.095v1.947c.312.067.613.142.903.225.717.205 1.241.415 1.544.566a1 1 0 0 1-.895 1.789c-.197-.099-.608-.263-1.2-.432a11.334 11.334 0 0 0-.352-.095v1.946c.307.066.607.141.899.224.719.206 1.244.416 1.547.568a1 1 0 0 1-.894 1.788c-.197-.098-.61-.263-1.203-.432A12.202 12.202 0 0 0 25 29c-1.12 0-2.198.24-4.725.962C17.552 30.739 16.379 31 15 31c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568a1 1 0 0 1 .894-1.788c.197.098.61.263 1.203.432 1.008.289 2.135.462 3.35.462 1.12 0 2.198-.24 4.725-.962l.277-.078-.003-1.92C17.47 26.757 16.33 27 15 27c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568a1 1 0 0 1 .894-1.788c.197.098.61.263 1.203.432 1.008.289 2.135.462 3.35.462 1.12 0 2.196-.24 4.724-.961l.278-.08-.003-1.92C17.47 22.758 16.33 23 15 23c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568a1 1 0 0 1 .894-1.788c.197.098.61.263 1.203.432 1.008.289 2.135.462 3.35.462 1.12 0 2.196-.24 4.724-.961l.278-.08L20 13.086C20 10.836 21.78 9 23.993 9zm0 2h-.014C22.899 11 22 11.927 22 13.086v14.337c1.254-.307 2.081-.423 3-.423.34 0 .673.012 1 .034V18h-1a1 1 0 1 1 0-2h1v-1h-2a1 1 0 1 1 0-2h1.998c-.043-1.118-.924-2-1.991-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBigPegelPin);
export default __webpack_public_path__ + "static/media/blue-big-pegel-pin.79eb3c5e0ac9a5effa75c447e3e0ee48.svg";
export { ForwardRef as ReactComponent };